/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminGroupSaleMarketplace
 */
export interface AdminGroupSaleMarketplace {
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleMarketplace
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleMarketplace
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleMarketplace
     */
    link: string;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleMarketplace
     */
    price: number;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminGroupSaleMarketplace
     */
    type: AdminMarketplaceType;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleMarketplace
     */
    updatedAt: string;
}



export function AdminGroupSaleMarketplaceFromJSON(json: any): AdminGroupSaleMarketplace {
    return AdminGroupSaleMarketplaceFromJSONTyped(json, false);
}

export function AdminGroupSaleMarketplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGroupSaleMarketplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'link': json['link'],
        'price': json['price'],
        'type': AdminMarketplaceTypeFromJSON(json['type']),
        'updatedAt': json['updatedAt'],
    };
}

export function AdminGroupSaleMarketplaceToJSON(value?: AdminGroupSaleMarketplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'link': value.link,
        'price': value.price,
        'type': AdminMarketplaceTypeToJSON(value.type),
        'updatedAt': value.updatedAt,
    };
}

